// ponytail: el control es un <input type="range"> nativo — arrastre, teclado y
// accesibilidad salen gratis. Lo único que hace el JS es mover la variable CSS.
class LanzoAntesDespues extends HTMLElement {
  connectedCallback() {
    const range = this.querySelector('input[type="range"]');
    if (!range) return;
    const move = () => this.style.setProperty('--lanzo-ba-pos', `${range.value}%`);
    range.addEventListener('input', move);
    move();
  }
}

customElements.define('lanzo-antes-despues', LanzoAntesDespues);
